<!-- src/App.vue -->

<template>
  <template v-if="showNav">
    <NavBar />

    <div class="core-shell-page">
      <div
        v-if="showSnap"
        class="core-shell-snapshot-wrap"
      >
        <VenueSnapshot />
      </div>

      <main class="core-shell-content">
        <router-view v-slot="{ Component }">
          <component
            v-if="Component"
            :is="Component"
          />

          <div v-else></div>
        </router-view>
      </main>
    </div>
  </template>

  <main v-else>
    <router-view v-slot="{ Component }">
      <component
        v-if="Component"
        :is="Component"
      />

      <div v-else></div>
    </router-view>
  </main>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

import NavBar from "./components/NavBar.vue";
import VenueSnapshot from "./components/VenueSnapshot.vue";

/*
 * CoreDeck notifications.
 *
 * Installs Firebase Cloud Messaging device registration,
 * unread Materialize badges and foreground push handling.
 */
import "@/scripts/notifications/coreNotifications";

const route = useRoute();

const showNav = computed(() => !route.meta?.hideNav);
const showSnap = computed(() => !route.meta?.hideNav);
</script>

<style>
:root {
  --core-sidebar-width: 270px;
}

html,
body {
  height: 100%;

  margin: 0;

  font-family:
    "Roboto",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Oxygen,
    Ubuntu,
    Cantarell,
    "Helvetica Neue",
    Arial,
    sans-serif;
}

body {
  background: #f5f6f7;
}

.rounded {
  border-radius: 30px;
}

.core-shell-page {
  min-height: calc(100vh - 116px);

  margin-left: var(--core-sidebar-width);

  background: #f5f6f7;
}

.core-shell-content {
  min-width: 0;
}

.core-shell-snapshot-wrap {
  width: 92%;

  max-width: 1400px;

  margin: 0 auto;

  padding-top: 12px;
}

.core-shell-snapshot-wrap
.venue-snapshot-panel {
  margin-top: 0 !important;
}

@media (min-width: 993px) {
  .container {
    width: 92%;

    max-width: 1400px;
  }
}

@media (max-width: 992px) {
  .core-shell-page {
    margin-left: 0;
  }
}

@media (max-width: 600px) {
  .core-shell-snapshot-wrap {
    width: calc(100% - 24px);

    padding-top: 10px;
  }
}
</style>
